export const DEFAULT_GALLERY_INDEX = 0
